import { render, staticRenderFns } from "./text.vue?vue&type=template&id=817125a8"
import script from "./text.js?vue&type=script&lang=js&external"
export * from "./text.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports